import React from "react";
import PropTypes from "prop-types";
import { Box, Center, HStack, Text } from "native-base";
import colors from "../../constants/colors";

function Stepper(props) {
  const { step } = props;

  return (
    <HStack position="relative" maxWidth={380} width="100%" marginY={7}>
      <Box
        zIndex={1}
        position="absolute"
        width="100%"
        height={1}
        backgroundColor={colors.lighterGray}
      />
      <Box
        zIndex={2}
        position="absolute"
        width={`${(100 * (step - 1)) / 3}%`}
        height={1}
        backgroundColor={colors.secondary}
      />
      <HStack
        zIndex={3}
        width="100%"
        marginY={7}
        justifyContent="space-between"
        overflow="hidden">
        {[1, 2, 3, 4].map((i) => (
          <Center
            key={String(i)}
            width={50}
            height={50}
            borderRadius="50%"
            borderWidth={1}
            backgroundColor={i <= step ? colors.secondary : colors.stepper}
            borderColor={i <= step ? colors.secondary : colors.lighterGray}>
            <Text color={i <= step ? colors.white : colors.black}>{i}</Text>
          </Center>
        ))}
      </HStack>
    </HStack>
  );
}

Stepper.propTypes = {
  step: PropTypes.number.isRequired,
};

export default React.memo(Stepper);
